<template>
  <mds-empty-state
    :title="translate(emptyState.title)"
    :message="translate(emptyState.message)"
  >
    <template #mds-empty-state-actions>
      <mds-button
        v-if="emptyState.button"
        size="medium"
        variation="secondary"
        :icon="buttonIcon"
        @click="handleClick"
      >
        {{ translate(emptyState.button) }}
      </mds-button>
    </template>
  </mds-empty-state>
</template>

<script>
import MdsEmptyState from '@mds/empty-state'
import { MdsButton } from '@mds/button'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '../../config/i18n'
import { VIEWS } from '../../config/constants'

export default {
  name: 'EmptyState',
  components: {
    MdsEmptyState,
    MdsButton,
  },
  props: {
    feedId: {
      type: String,
      default: '',
    },
    emptyState: {
      type: Object,
      default: () => ({}),
    },
    view: {
      type: String,
      default: '',
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
  computed: {
    isFeedsView() {
      return this.view === VIEWS.feeds
    },
    buttonIcon() {
      return this.isFeedsView ? 'calendar' : 'chat-bubble'
    },
  },
  methods: {
    handleClick() {
      if (this.isFeedsView) {
        this.$emit('scheduleFeed', this.feedId, true)
      }
    },
  },
}
</script>
